import gql from 'graphql-tag';

import printProductBaseDetails from './printProductBaseDetails';
import printProductSizeBaseDetails from './printProductSizeBaseDetails';
import { VendorDetails } from '../../../../../../../graphql/fragments/account';

const albumMembershipGroupPhotoPricing = gql`
  fragment albumMembershipGroupPhotoPricing on AlbumMembershipGroup {
    id
    photo_pricing {
      id
      account {
        ...VendorDetails
      }
      digital_downloads_price {
        value
        currency
      }
      requires_package_purchase
      print_product_items(slice: { limit: 99 }) {
        total
        records {
          id
          print_product {
            ...printProductBaseDetails
          }
          print_product_size {
            ...printProductSizeBaseDetails
          }
          print_product_size_mount {
            id
          }
          name
          price {
            currency
            value
          }
        }
      }
      print_items(slice: { limit: 99 }) {
        total
        records {
          id
          price {
            value
            currency
          }
          type {
            id
            name
          }
        }
      }
    }
  }
  ${printProductBaseDetails}
  ${printProductSizeBaseDetails}
  ${VendorDetails}
`;

export default albumMembershipGroupPhotoPricing;
